const ActionTypes = {
  SHOW_TOAST: `[Application] Show Toast`,
  SHOW_ERROR_TOAST: `[Application] Show Error Toast`,
  SET_DEVICE_INFO: `[Application] Set Device Info`,
};

export class ShowToastAction {
  static type = ActionTypes.SHOW_TOAST;

  constructor(public message: string) {
  }
}

export class ShowErrorToastAction {
  static type = ActionTypes.SHOW_ERROR_TOAST;

  constructor(public message: string) {
  }
}

export class SetDeviceInfoAction {
  static type = ActionTypes.SET_DEVICE_INFO;

  constructor(public payload?: any) {
  }
}
